import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { useAuth } from '@/features/auth/auth-context'
import { exchangeImpersonationCode } from '@/features/auth/impersonation-api'
import { LoadingBlock } from '@/shared/components/common/loading-block'

export function ImpersonatePage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const { adoptImpersonation } = useAuth()
  const [failed, setFailed] = useState(false)
  // Код одноразовый: в StrictMode эффект вызывается дважды, второй обмен
  // получил бы 404 и увёл на экран ошибки.
  const started = useRef(false)
  const code = params.get('code')

  useEffect(() => {
    if (started.current || !code) {
      return
    }
    started.current = true

    exchangeImpersonationCode(code)
      .then((payload) => {
        adoptImpersonation(payload)
        navigate('/', { replace: true })
      })
      .catch(() => setFailed(true))
  }, [adoptImpersonation, code, navigate])

  if (failed || !code) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-2 px-4 text-center">
        <p className="text-lg font-medium">Ссылка устарела или уже использована</p>
        <p className="text-sm text-[var(--color-text-muted)]">
          Вернитесь в админку и нажмите «Войти в кабинет» ещё раз.
        </p>
      </div>
    )
  }

  return <LoadingBlock label="Открываем кабинет..." />
}
